import { Skeleton } from '../ui/skeleton'
import { ChevronDown } from 'lucide-react'

const MFOrdersSkeleton = () => {
  return (
    <div className='w-full mx-auto mt-12 space-y-6'>
      {/* List Items */}
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className='flex items-center justify-between p-4 border rounded-lg'>
          <div className='flex items-center gap-4'>
            <Skeleton className='h-12 w-12 rounded' />
            <div className='space-y-2'>
              <Skeleton className='h-4 w-48' />
              <Skeleton className='h-4 w-16' />
            </div>
          </div>
          <div className='flex items-center gap-4'>
            <Skeleton className='h-9 w-20 rounded-md' />
            <ChevronDown className='h-5 w-5 text-muted-foreground' />
          </div>
        </div>
      ))}
    </div>
  )
}

export default MFOrdersSkeleton
